<mat-toolbar class="sidemenu-toolbar">
  <i class="icon mdi mdi-publish"></i>
  <span class="title">Publish</span>
</mat-toolbar>

<mat-accordion displayMode="flat" togglePosition="after">
  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>android</mat-icon>
        <div class="ms-3"> Build Android App</div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="mt-2 mb-2">
      <button mat-stroked-button class="w-100 mb-2" *ngIf="!showDetails"
        (click)="openModal(apkDetails)"><mat-icon>add</mat-icon> Add
        Information</button>
      <div class="application-details mb-3 rounded-2" *ngIf="showDetails" (click)="openModal(apkDetails)">

        <mat-list class="info-list">
          <button mat-icon-button class="edit" color="primary">
            <mat-icon>edit</mat-icon>
          </button>

          <mat-list-item>
            <div matListItemLine>Application Name</div>
            <div matListItemTitle>{{this.applicationDetails.get('applicationName')?.value}}</div>


          </mat-list-item>
          <mat-list-item>
            <div matListItemLine>Application ID</div>
            <div matListItemTitle>{{this.applicationDetails.get('playstoreApplicationId')?.value}}</div>
          </mat-list-item>
          <mat-list-item>
            <div matListItemLine>Application Version</div>
            <div matListItemTitle>{{this.applicationDetails.get('applicationVersion')?.value}}</div>
          </mat-list-item>
        </mat-list>
      </div>
      <div class="alert alert-warning mx-3 custom-background" *ngIf="fetchingAPKDetails">
        <strong>**Generating Your App**</strong><br><br>
        Please wait while we create your personalized experience. This process should take no more than 10-12 minutes.
        You can navigate away and check back later. We'll notify you once your app is ready.<br><br>
        Thank you for your patience!
      </div>
      <div *ngIf="fetchingAPKDetails" class="genarating-app  mx-3">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <span class="text-muted fw-medium">Genarating the mobile APK</span>
      </div>
      @if([appPermissions.publish,permissionsActions.edit] | builderPermissions){
        <button mat-raised-button *ngIf="!fetchingAPKDetails" class="w-100 mb-2" (click)="publishApiCall()"
          [disabled]="!publishStatus || isPublished || fetchingAPKDetails"> <mat-icon>build</mat-icon> Build apk
        </button>
      }
      <div *ngIf="downLoadURL" class="genarated-link mt-2">
        <div class="link-text alert alert-primary"
          [ngClass]="{'alert-success': apkStatus === 'created' || apkStatus === 'updated', 'alert-danger': apkStatus !== 'created' && apkStatus !== 'updated'}">
          {{ errorMessage }}
        </div>
        <div class="link-text alert alert-primary" (click)="$event.preventDefault()">
          <h6>Apk URL</h6>  
          <div class="copy-url" (click)="copyToClipboard(downLoadURL)">
            <span class="ellipsis-input">{{ downLoadURL }}</span>
            <mat-icon>content_copy</mat-icon>
          </div>
        </div>

        <div>
          <p class="mb-0 pb-0 mt-2">
            <small>To publish your app on Google Play Store, please follow the steps outlined in the
              document provided here:  <a
              href="https://support.google.com/googleplay/android-developer/answer/9859152?hl=en" target="_blank"><strong
                >Google Play Developer Guide</strong></a> </small>
          </p>
        </div>
        <div *ngIf="downLoadURL=='' && apkStatus=='failed'" class="genarated-link  mx-3">
          <div class="link-text alert alert-primary" [ngClass]="{ 'alert-danger': apkStatus=='failed'}"
            *ngIf="!fetchingAPKDetails">
            Could not create apk. Something went wrong!
          </div>
        </div>
      </div>
      <button mat-raised-button class="w-100" color="primary" (click)="downloadAPK(downLoadURL)"
        *ngIf="downLoadURL && applicationDetails.valid && certificateDetails.valid">
        <mat-icon>download</mat-icon> Download APK
      </button>
    </div>
  </mat-expansion-panel>
    <mat-expansion-panel *ngIf="versionList?.length > 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>history</mat-icon>
          <div class="ms-3">Version History</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-list>
        <mat-list-item *ngFor="let version of versionList">
          <div matListItemTitle>{{version?.applicationVersion}}</div>
          <div matListItemLine class="d-flex">
            <span>{{version?.createdDate | date:'dd-MMM-yyyy, hh:mm a'}}</span>
             <span class="flex-fill"></span> <span class="d-flex align-items-center gap-1  "[matTooltip]="version?.createdByFullName?.length > 10 ? version?.createdByFullName : ''" ><mat-icon class="icon-size">account_circle</mat-icon>{{version?.createdByFullName | titlecase | truncate:10}}</span></div>
        </mat-list-item>
      </mat-list>
    </mat-expansion-panel>
</mat-accordion>


<ng-template #apkDetails>
  <mat-dialog-content class="add-page-dailog">
    <mat-stepper #stepper [linear]="true">
      <mat-step label="Basic Information" [stepControl]="applicationDetails">
        <form [formGroup]="applicationDetails">
          <div class="row">
            <div class="col-8">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Application Name</mat-label>
                <input cdkFocusInitial matInput type="text" formControlName="applicationName" placeholder="App Name"
                  spellcheck="false" />
                <mat-error>This field is required</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Application Id</mat-label>
                <input type="text" matInput formControlName="playstoreApplicationId" placeholder="com.example.myApp">
                <mat-error
                  *ngIf="applicationDetails.controls['playstoreApplicationId'].errors && !applicationDetails.controls['playstoreApplicationId'].errors['required']">Enter
                  Valid Application Id Ex: com.example.myApp</mat-error>
                <mat-error
                  *ngIf="applicationDetails.controls['playstoreApplicationId'].errors && applicationDetails.controls['playstoreApplicationId'].errors['required']">This
                  field is required</mat-error>

              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100 mt-2">
                <mat-label>Application Version</mat-label>
                <input type="text" matInput formControlName="applicationVersion" placeholder="0.0.0">
                <mat-error
                  *ngIf="applicationDetails.controls['applicationVersion'].errors && !applicationDetails.controls['applicationVersion'].errors['required']">Enter
                  Valid Application Version Ex: 0.0.0</mat-error>
                <mat-error
                  *ngIf="applicationDetails.controls['applicationVersion'].errors && applicationDetails.controls['applicationVersion'].errors['required']">This
                  field is required</mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <div class="app-icon-container">

                <div class="icon-img-container" matRipple (click)="fileInput.click()">
                  <input #fileInput type="file" (change)="onfileChange($event)" style="display: none;">
                  <img [src]="imageSrc" class="w-100" alt="logo">
                  <div class="edit-icon">
                    <mat-icon>edit</mat-icon>
                  </div>
                </div>
                <div class="hint">App Icon</div>
              </div>

            </div>
          </div>
        </form>
      </mat-step>
      <mat-step label="Certificate" [stepControl]="certificateDetails">
        <form [formGroup]="certificateDetails">
          <div class="row">
            <div class="col-6"><mat-form-field appearance="outline" class="w-100">
                <mat-label>First And Last Name</mat-label>
                <input matInput formControlName="firstAndLastName" placeholder="First and Last Name">
              </mat-form-field></div>
            <div class="col-6"><mat-form-field appearance="outline" class="w-100">
                <mat-label>Organizational Unit</mat-label>
                <input matInput formControlName="organizationalUnit" placeholder="Organizational Unit">
              </mat-form-field></div>
            <div class="col-6"><mat-form-field appearance="outline" class="w-100">
                <mat-label>Organization</mat-label>
                <input matInput formControlName="organization" placeholder="Organization">
              </mat-form-field></div>
            <div class="col-6"> <mat-form-field appearance="outline" class="w-100">
                <mat-label>City or Locality</mat-label>
                <input matInput formControlName="cityOrLocality" placeholder="City or Locality">
              </mat-form-field></div>
            <div class="col-6"> <mat-form-field appearance="outline" class="w-100">
                <mat-label>State or Province</mat-label>
                <input matInput formControlName="stateOrProvince" placeholder="State or Province">
              </mat-form-field></div>
            <div class="col-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Country Code (xx)</mat-label>
                <input matInput formControlName="countryCode" placeholder="Country Code">
              </mat-form-field>
            </div>
          </div>

        </form>

      </mat-step>
    </mat-stepper>
  </mat-dialog-content>
  <mat-dialog-actions class="dailog-footer-buttons">
    <button mat-stroked-button (click)="closeTemplate()">Cancel</button>
    <button mat-raised-button color="primary"
      [disabled]="( stepper.selectedIndex == 0 && applicationDetails.invalid) || (stepper.selectedIndex === 1 && certificateDetails.invalid)"
      (click)="saveApkDetails(stepper)">
      {{ stepper.selectedIndex == 0 ? 'Next' : 'Save'}}
    </button>
  </mat-dialog-actions>
</ng-template>